import React, { useEffect, useState } from 'react';
import { useSprings, animated, to as interpolate } from '@react-spring/web';
import { useDrag } from 'react-use-gesture';

const to = (i) => ({
    x: 0,
    y: i * Math.abs(-1 + Math.random() * 5),
    scale: 1,
    rot: -1 + Math.random() * 5,
    delay: i * 300,
});
const from = () => ({ x: 0, y: -1000, scale: 1.5, rot: 0 });
const trans = (r, s) =>
    `perspective(1500px) rotateX(30deg) rotateY(${r / 10}deg) rotateZ(${r}deg) scale(${s})`;

export const CardStack = () => {
    const [gone] = useState(() => new Set());
    const [color, setColor] = useState('transparent');
    const [cards, setCards] = useState([]);
    const [springs, api] = useSprings(cards.length, (i) => from(i));

    useEffect(() => {

        window.VTWidgetBridge.Bridge.getAttributes(["vtJsonCards", "vtColorBackground"])
          .defaultValues({
            vtJsonCards: "[]",
            vtColorBackground: "transparent",
          })
          .then((attrs) => {
            setColor(attrs.vtColorBackground);
            setTimeout(() => {
              const parsedCards = JSON.parse(attrs.vtJsonCards);
              setCards(parsedCards);
            }, 3000);
          });


    }, []);

    // Iniciar animaciones cuando se actualizan las cards
    useEffect(() => {
        api.start((i) => ({ ...to(i), from: from(i) }));
    }, [cards, api]);

    const bind = useDrag(
        ({ args: [index], down, movement: [mx], direction: [xDir], velocity }) => {
            const trigger = velocity > 0.2;
            const dir = xDir < 0 ? -1 : 1;

            if (!down && trigger) {
                gone.add(index);
                /*
                window.VTWidgetBridge?.Bridge.raiseEvent?.("vtOnDragCard", {
                    "vtImage":cards[index].imagen,
                    "vtTitle":cards[index].titulo,
                    "vtDescription":cards[index].descripcion,
                    "vtCampaignId":cards[index].campana_id,
                    "vtLoanId":cards[index].loan_id,
                    "vtModule":cards[index].module
                });

                 */
            }

            api.start((i) => {
                if (index !== i) return;
                const isGone = gone.has(index);
                const x = isGone ? (window.innerWidth + 200) * dir : down ? mx : 0;
                const rot = mx / 100 + (isGone ? dir * 10 * velocity : 0);
                const scale = down ? 1.05 : 1;
                return {
                    x,
                    rot,
                    scale,
                    delay: undefined,
                    config: { friction: 50, tension: down ? 800 : isGone ? 200 : 500 },
                };
            });

            if (!down && gone.size === cards.length) {
                setTimeout(() => {
                    gone.clear();
                    api.start((i) => to(i));
                }, 600);
            }
        }
    );

    return (
        <div
            style={{ backgroundColor: color }}
            className="w-screen h-screen flex items-center justify-center overflow-hidden relative bg-gray-100"
        >
            {springs.map(({ x, y, rot, scale }, i) => (
                <animated.div
                    key={i}
                    className="absolute touch-none"
                    style={{
                        transform: interpolate([x, y], (x, y) => `translate3d(${x}px,${y}px,0)`),
                    }}
                >
                    <animated.div
                        {...bind(i)}
                        className="w-[90vw] max-w-[900px] aspect-[661/424] rounded-xl bg-center bg-cover cursor-grab"
                        /*
                     onClick={() =>
                         window.VTWidgetBridge?.Bridge.raiseEvent?.("vtOnClick", {
                             "vtImage":cards[i].imagen,
                             "vtTitle":cards[i].titulo,
                             "vtDescription":cards[i].descripcion,
                             "vtCampaignId":cards[i].campana_id,
                             "vtLoanId":cards[i].loan_id,
                             "vtModule":cards[i].module
                         })}
                         */

                        style={{
                            transform: interpolate([rot, scale], trans),
                            backgroundImage: `url(${cards[i].imagen})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }}
                    />
                </animated.div>
            ))}
        </div>
    );
};

export default CardStack;
